export const MIN_FEEDBACK_LENGTH = 10;
export const pageSize = 5;

export const categoryConfig = {
  "General Feedback": { color: "#4CAF50", key: "general-feedback" },
  Suggestions: { color: "#2196F3", key: "suggestions" },
  "Bug Report": { color: "#FF5722", key: "bug-report" },
};

export const categoryOptions = [
  {
    key: "general-feedback",
    value: "General Feedback",
    text: "General Feedback",
  },
  { key: "suggestions", value: "Suggestions", text: "Suggestions" },
  { key: "bug-report", value: "Bug Report", text: "Bug Report" },
];
